module.exports = __webpack_public_path__ + "img/iShow.ef9366df.jpg";